'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useState } from 'react'

export const SupportLink = () => {
    const pathname = usePathname()
    const active = pathname === '/support'
    const [hovered, setHovered] = useState(false)

    const color = active || hovered ? 'var(--primary-color)' : '#6b7280'

    return (
        <Link
            href="/support"
            className="no-underline flex flex-column align-items-center justify-content-center gap-1 px-2 md:px-3 py-2 border-round-lg cursor-pointer transition-all transition-duration-200"
            style={{
                minWidth: '3.5rem',
                background: hovered ? 'var(--primary-50)' : 'transparent',
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <i className="pi pi-headphones" style={{ fontSize: '1.35rem', height:'1.75rem', color, transition: 'color 0.2s' }} />
            <span style={{
                fontSize: '0.6rem',
                fontWeight: 600,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                color,
                transition: 'color 0.2s',
                lineHeight: 1,
            }}>
                Support
            </span>
        </Link>
    )
}
